export default "__VITE_PUBLIC_ASSET__ae9347ff__"